/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DeadwoodRip} from "../DeadwoodRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";

export class DeadwoodRipFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController) {
        if(DeadwoodRip.model.isRestore) {
            SlotGame.keypadPlugin.setWin(DeadwoodRip.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
            await new Promise<void>(resolve => {
                DeadwoodRip.freespinIntro.show(resolve);
            });
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DeadwoodRip.model.parsedInitData.freespinsLeft - 1);
        } else {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DeadwoodRip.model.parsedGameData.freespinsLeft - 1);
        }

        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}